export enum AltitudeType {
  AGL = "AGL",
  MSL = "MSL",
  Pressure = "Pressure",
}

export enum AltitudeLevels {
  Normalized = "Normalized",
  Raw = "Raw",
}

// CSS scroll-snap-stop
export enum OnOff {
  On = "On",
  Off = "Off",
}

export enum SpeedUnit {
  KPH = "km/h",
  MPH = "mph",
  Knots = "knots",
  mps = "m/s",
}

export enum HeightUnit {
  Feet = "ft",
  Meters = "m",
}

export enum TemperatureUnit {
  Celsius = "°C",
  Fahrenheit = "°F",
}

export enum DistanceUnit {
  Miles = "miles",
  Kilometers = "km",
}

export enum TimeFormat {
  TwentyFour = "24-hour",
  Twelve = "12-hour",
}
